import React, { useEffect, useState } from 'react';
import { FormGroup, Input, Label } from 'reactstrap';

import 'style/layout/Forms.css';

const hasOnlyZeros = (value: string) =>
  /^0*$/.test(value) || /^0*,0*$/.test(value);

const DecimalInputField = ({
  className,
  disabled,
  error,
  id,
  label,
  name,
  onChange,
  required,
  value,
}: {
  className?: string;
  disabled?: boolean;
  error?: string;
  id: string;
  label?: string;
  name?: string;
  onChange?: any;
  required?: boolean;
  value: number;
}): JSX.Element => {
  const [displayValue, setDisplayValue] = useState(value.toString());

  useEffect(() => {
    const displayValueIsZero =
      displayValue === '' || hasOnlyZeros(displayValue);

    if (value === 0 && displayValueIsZero) {
      return;
    }

    if (value.toString() !== displayValue.replace(/,/g, '.')) {
      onDisplayValueChange(value.toString());
    }
  }, [value]);

  const onDisplayValueChange = (newValue: string) => {
    if (onChange === undefined) {
      return;
    }

    setDisplayValue(newValue.replace(/\./g, ','));

    const valueForParse = newValue.replace(/,\s*$/, '').replace(/,/g, '.');

    if (valueForParse === '' || Number.isNaN(Number(valueForParse))) {
      onChange({
        target: { name, value: 0 },
      });

      return;
    }

    onChange({
      target: {
        name,
        value: parseFloat(valueForParse),
      },
    });
  };

  const handleOnChangeEvent = (event: React.ChangeEvent<HTMLInputElement>) =>
    onDisplayValueChange(event.target.value);

  const getErrorMessage = () => {
    if (error === undefined) {
      return null;
    }

    return <span className="input-error-message">{error}</span>;
  };

  return (
    <FormGroup>
      {label === undefined ? null : (
        <Label className="label" for={id}>
          {label}
        </Label>
      )}
      <Input
        className={`text-field ${className}`}
        disabled={disabled}
        id={id}
        name={name}
        required={required === undefined ? false : required}
        onChange={handleOnChangeEvent}
        value={displayValue}
        type="text"
      />
      {getErrorMessage()}
    </FormGroup>
  );
};

export default DecimalInputField;
